module.exports = __webpack_public_path__ + "img/he.631d4ced.png";